import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomerProfileLayer from "./CustomerProfileLayer";
import customerService from "../services/customerService";
import { toast } from "react-toastify";

const CustomerProfilePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        setLoading(true);
        const data = await customerService.getCustomer(id);
        setCustomer(data);
      } catch (err) {
        console.error('Failed to fetch customer:', err);
        setError('Failed to load customer data');
        toast.error('Failed to load customer');
        navigate('/admin/customers');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchCustomer();
    }
  }, [id, navigate]);

  if (loading) {
    return (
      <MasterLayout>
        <Breadcrumb title="Loading..." />
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </MasterLayout>
    );
  }

  if (error) {
    return (
      <MasterLayout>
        <Breadcrumb title="Error" />
        <div className="alert alert-danger">{error}</div>
      </MasterLayout>
    );
  }

  const handleUpdateCustomer = async (formData) => {
    try {
      const updatedCustomer = await customerService.updateCustomer(id, formData);
      setCustomer(updatedCustomer);
      toast.success('Customer updated successfully');
      return updatedCustomer;
    } catch (error) {
      console.error('Error updating customer:', error);
      throw error;
    }
  };

  return (
    <>
      <MasterLayout>
        <Breadcrumb 
          title={customer ? `${customer.company_name} - Profile` : 'Customer Profile'} 
          items={[
            { title: 'Customers', link: '/admin/customers' },
            { title: customer ? customer.company_name : 'Profile' }
          ]} 
        />
        {customer && (
          <CustomerProfileLayer 
            customer={customer} 
            onUpdate={handleUpdateCustomer} 
          />
        )}
      </MasterLayout>
    </>
  );
};

export default CustomerProfilePage;
